/**
 * @file Flush Queue related actions.
 */

export const SET_FLUSH_MODE = 'flush/SET_FLUSH_MODE';

export const setFlushMode = flushMode => {
  return {
    type: SET_FLUSH_MODE,
    flushMode,
  };
};
